// extracted by mini-css-extract-plugin
module.exports = {"sider_box":"sider_box-2937j3Lg","sider":"sider-1gCgGm2A","ipad_sider":"ipad_sider-2EFbTe5c"};